import {
  RequestBody,
  RequestOptions,
  SerializedBlob,
  SerializedFormData,
  SerializedResponse,
  SerializedRequestBody,
  SerializedRequestOptions,
} from './types';
import { createReadableStream } from './utils';

export const deserializeBlob = (serializedBlob: SerializedBlob): Blob => {
  const { content: dataURI } = serializedBlob;
  const [meta, data] = dataURI.split(',');
  const byteString = atob(data);
  const mimeType = meta.split(':')[1].split(';')[0];

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  const opts = { type: mimeType };

  return serializedBlob.name ? new File([ab], serializedBlob.name, opts) : new Blob([ab], opts);
};

export const deserializeFormData = (serializedFormData: SerializedFormData): FormData => {
  const formData = new FormData();
  Object.keys(serializedFormData).forEach((key) => {
    const values = serializedFormData[key];
    values.forEach((v) => {
      if (typeof v === 'object') {
        formData.append(key, deserializeBlob(v));
      } else {
        formData.append(key, v);
      }
    });
  });

  return formData;
};

export const deserializeRequestBody = (body: SerializedRequestBody): RequestBody => {
  if (body === null) return null;

  if (body.type === 'Blob') {
    return deserializeBlob(body.content as SerializedBlob);
  }

  if (body.type === 'URLSearchParams') {
    return new URLSearchParams(body.content as string);
  }

  if (body.type === 'FormData') {
    return deserializeFormData(body.content as SerializedFormData);
  }

  return body.content as string;
};

export const deserializeResponse = (serializedResponse: SerializedResponse): Response => {
  const { body } = serializedResponse;
  const readableStream = body ? createReadableStream(body) : null;

  return new Response(readableStream, {
    headers: serializedResponse.headers,
    status: serializedResponse.status,
    statusText: serializedResponse.statusText,
  });
};

export const deserializeRequestOptions = (options: SerializedRequestOptions): RequestOptions => {
  const { body, ...rest } = options;

  return {
    ...rest,
    ...(body !== undefined ? { body: deserializeRequestBody(body) } : {}),
  };
};
